import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import RequestsComponent from '../components/RequestsComponent'

const mapStateToProps = (state) => {
  return {
    requests: state,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RequestsComponent)
